import { INamedEntity, ITimestampedEntity } from 'src/models/IEntity'

export enum WorkspaceStatus {
    Ready = 'READY',
    Provisioning = 'PROVISIONING',
    Failed = 'FAILED'
}

export enum MeltanoVersion {
    V3_9 = 'V3_9',
    V4_2 = 'V4_2',
}

export default interface IWorkspace extends INamedEntity, ITimestampedEntity {
    alias: string
    domains: string
    repositoryUrl: string
    repositoryBranch: string
    repositoryDirectory: string
    imageUrl: string
    status: WorkspaceStatus
    defaultWorkspace: boolean
    managed: boolean
    defaultEnvironment?: string
    /** No pipeline runs on its schedule here; set by the environment's workspace-<env>.yml (MEL-752) */
    disablePipelineSchedules?: boolean
    sshPrivateKey: string
    githubInstallationId: string
    meltanoVersion?: MeltanoVersion | null
}
